import React from 'react';
import { Buttons, Form, FormGrid, LoadingIndicator } from '../../toolympus/components/primitives';
import { ProcessStatusDateCurrentKey, ProcessStatusDatePrevKey, StatusDateCurrentKey, StatusDatePrevKey, useAppSettings } from './useAppSettings';
import { Badge, Button, Typography } from '@mui/material';
import { FormControlsForFields } from '../../toolympus/components/schemed';
import { ArrowRightAlt } from '@mui/icons-material';
import { FormSectionPane } from '../../toolympus/components/primitives/PaneContainer';

interface Props {
  
}

export const SettingsPage = (props: Props) => {
  const data = useAppSettings();

  return (<>
    <Form
      title="Настройки"
      headerItems={<>
        {!!data.hasChanges && <Badge color="primary" variant="dot" invisible={false} />}
        {!!data.isLoadingGlobal && <LoadingIndicator sizeVariant="s" />}
      </>}>

        <FormGrid>
          <FormGrid noMargin columns="240px">
            <Buttons>
              <Typography variant="caption" color="textSecondary">Даты статусов проектов</Typography>
            </Buttons>

            <FormControlsForFields
              data={data.global}
              onChange={(o,c) => data.update(c)}
              fields={[
                [StatusDateCurrentKey],
                [StatusDatePrevKey],
              ]}
              schema={data.schema}
              />

            <Button
              endIcon={<ArrowRightAlt />}
              color="primary"
              onClick={() => data.advanceStatusDatesProject()}
              disabled={data.hasChanges}>
              обновить
            </Button>
          </FormGrid>

          <FormGrid noMargin columns="240px">
            <Buttons>
              <Typography variant="caption" color="textSecondary">Даты статусов процессов</Typography>
            </Buttons>

            <FormControlsForFields
              data={data.global}
              onChange={(o,c) => data.update(c)}
              fields={[
                [ProcessStatusDateCurrentKey],
                [ProcessStatusDatePrevKey],
              ]}
              schema={data.schema}
              />

            <Button
              endIcon={<ArrowRightAlt />}
              color="primary"
              onClick={() => data.advanceStatusDatesProcess()}
              disabled={data.hasChanges}>
              обновить
            </Button>
          </FormGrid>
        </FormGrid>

        <FormGrid columns="1fr 1fr">
          <FormSectionPane title="Редактура">
            <FormGrid columns="1fr" noMargin>
              <FormControlsForFields
                data={data.global}
                onChange={(o,c) => data.update(c)}
                fields={[
                  ["editing_buffer_days"],
                  ["editing_speed_pages_per_day"],
                  ["editing_support"],
                ]}
                schema={data.schema}
                />
            </FormGrid>
          </FormSectionPane>
        </FormGrid>
    </Form>
  </>);
}
